<template>
  <div id="search-content">
    <v-container grid-list-xl pt-0>
      <v-layout align-center justify-center row wrap>
        <v-flex xs10>
          <div class="display-3 head-page">สะดวกกว่า</div>
          <div class="headline head-page">กับการค้นหาบทความผลผลิตที่คุณสนใจ</div>
        </v-flex>
        <v-flex xs10>
          <v-text-field
            @keyup.enter="onSearch()"
            class="search-box font-THSarabunNew"
            hide-details
            outline
            placeholder="ชื่อผลผลิต"
            single-line
            v-model="searchContentText"
          >
            <v-btn @click="onSearch()" color="#5d5d5d" depressed slot="append">
              <v-icon color="#fff">search</v-icon>
            </v-btn>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'search-content',
  data() {
    return {
      searchContentText: ''
    }
  },
  methods: {
    onSearch() {
      this.$router.push(`/content/search/${this.searchContentText}`)
    }
  }
}
</script>

<style lang="scss">
#search-content {
  .v-input__append-inner {
    margin-top: 0px;
    & .v-btn {
      border-radius: 0px;
      height: 44px;
      margin: 0px;
    }
  }
  .search-box {
    & .v-input__control {
      & .v-input__slot {
        min-height: 28px;
        border-radius: 0px;
        border: 1px solid #5d5d5d;
        padding-left: 38px;
        padding-right: 0px;
        & input {
          margin-top: 7px;
          font-size: 24px;
        }
        & .v-btn {
          min-width: 72px;
          width: 72px;
        }
        & ::placeholder {
          color: #000;
          font-size: 24px;
        }
        & .v-icon {
          font-size: 44px;
        }
      }
    }
  }
}
</style>
